<template>
   <v-row :class="`item ${item.nodeDescription.class}`">
        <v-col
            cols="3"
            sm="2"
            md="2"
            lg="1"
        >
            <!-- <div>{{ item.nodeDescription.class }}</div>
            <div class="text-caption grey--text">{{ item.nodeDescription.groupName }}</div> -->
            <div>{{ index + 1 }}</div>
            <div class="text-caption grey--text">{{ item.nodeDescription.id }}</div>
        </v-col>            
        <v-col
            cols="9"
            sm="7"
            md="3"
            lg="3"
        >
            <router-link :to="{ name: 'SingleItem', params: { timestamp: item.timestamp } }">
            {{ item.nodeDescription.hangeul }}
            </router-link>
            <div class="text-caption grey--text">{{ item.nodeDescription.english }}</div>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="2"
            lg="2"
        >
            <div>{{ item.nodeDescription.hanja }}</div>
            <div v-if="item.birthYear || item.deathYear" class="text-caption grey--text">{{ item.birthYear }}~{{ item.deathYear }}</div>
        </v-col>
        <v-col
            cols="9"
            sm="9"
            md="4"
            lg="5"
        >
            <div class="text-truncate">
            {{ item.content }}
            </div>
            <div>
            <span class="text-caption grey--text">{{ item.nodeDescription.infoUrl }}</span>
            <v-btn class="grey--text" text small :href="item.nodeDescription.infoUrl" target="_blank">
                <v-icon small class="blue-grey--text text--lighten-3">mdi-open-in-new</v-icon>
            </v-btn>
            </div>
        </v-col>
        <v-col
            cols="3"
            sm="3"
            md="1"
            lg="1"
        >
            <router-link :to="{ name: 'EditItem', params: { timestamp: item.timestamp }}">
                <v-btn icon>
                    <v-icon class="blue-grey--text">mdi-pencil</v-icon>
                </v-btn>
            </router-link>
            <v-btn icon @click="toggleComplete(item.id)">
                <v-icon :class="{complete: item.complete}">mdi-check</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { db } from '../firebase/init'

export default {
    props: ['item', 'index'],
    data() {
        return {

        }
    },
    methods: {
        toggleComplete(id) {
            const ref = db.collection('items').doc(id)
            if(this.item.complete == null) {
                ref.update({
                    complete: false,
                }).then(() => {
                    console.log('initialized to be false')
                })
            } else {
                ref.update({
                    complete: !this.item.complete,
                }).then(() => {
                    this.item.complete = !this.item.complete
                })
            }
        },
        // deleteItem(id){
        //     db.collection('items').doc(id).delete().then(() => {
        //         this.items = this.items.filter(item => {
        //             return item.id != id;
        //         })
        //     })
        // },
    }
}
</script>

<style scoped>
    .v-icon.complete {
        color: chocolate;
    }
</style>